module.exports = __webpack_public_path__ + "static/media/star.e0979cb0.svg";